<article>
  @if (advert().showNumberOfRooms) {
    <span>
      {{ advert().numberOfRooms }}
      {{ advert().numberOfRoomsLabel | translate }},
    </span>
  }
  @if (advert().showMarketingNumberOfRooms) {
    <span>
      {{ advert().marketingNumberOfRooms }}
      {{ advert().numberOfRoomsLabel | translate }},
    </span>
  }

  @if (advert().showNumberOfBedrooms) {
    <span>
      {{ advert().numberOfBedrooms }}
      {{ advert().numberOfBedroomsLabel | translate }},
    </span>
  }
  @if (advert().showMarketingNumberOfBedrooms) {
    <span>
      {{ advert().marketingNumberOfBedrooms }}
      {{ advert().numberOfBedroomsLabel | translate }},
    </span>
  }

  @if (advert().showUnitSize) {
    <span> {{ advert().size | numeral }} {{ advert().areaSizeUnit }} </span>
  }
  @if (advert().showMarketingUnitSize) {
    <span> {{ advert().marketingSize | numeral }} {{ advert().areaSizeUnit }} </span>
  }
</article>
